import {Component, Input, OnInit} from "@angular/core";

@Component({
    selector: 'app-general-heading',
    templateUrl: './heading.component.html',
    standalone: false
})
export class HeadingComponent implements OnInit {

  @Input("header1") header1: string;
  @Input("header2") header2: string;
  @Input() light = false;
  @Input() contained = false;

  ngOnInit(): void {
  }
}
